<template>
    <div class="h-100 d-flex flex-column">
        <master-header></master-header>
        <div id="main">
        <master-sidebar></master-sidebar>
        <div id="main-content">
            <div id="router-view">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
            </div>
            <master-footer></master-footer>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
#main {
  height: 100%;
  width: 100%;
  display:flex;
}

#main-content {
  height:100%;
  width:100%;
  display:flex;
  flex-direction: column;
}

#router-view {
  height: 100%;
  width: 100%;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .05s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.15s;
}
.slide-enter {
  transform: translateX(-100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}

.slideup-enter-active, .slideup-leave-active {
  transition: max-height 0.25s ease;
  max-height: 100%;
  overflow-y: hidden !important;
  > div.w-100.h-100 {
    overflow-y: hidden !important;
  }
}
.slideup-enter, .slideup-leave-to {
  max-height: 0;
  overflow-y: hidden !important;
  > div.w-100.h-100 {
    overflow-y: hidden !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/master/master.vue